import React from 'react'
import htmlRetriever from '../../services/html-retriever/html-retriever'

//Currently only have isAdvancedSearch as a featureToggle
const featureToggles = htmlRetriever.get('featureToggles') || {}

export const FeatureTogglesContext = React.createContext(featureToggles)

export const FeatureTogglesProvider = ({ children }) => (
  <FeatureTogglesContext.Provider value={featureToggles}>
    {children}
  </FeatureTogglesContext.Provider>
)
